import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-quote-close",
  "use": "icon-quote-close-usage",
  "viewBox": "0 0 33 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 33 25\" id=\"icon-quote-close\"><path d=\"M20.93,25l-.8-1.64a32.27,32.27,0,0,0,4.72-3.88q3.2-3.29,3.2-6,0-1.64-1.45-1.64H25a5.3,5.3,0,0,1-3.42-1.1,5.63,5.63,0,0,1-2-4.71A5.87,5.87,0,0,1,21.3,1.62,5.91,5.91,0,0,1,25.59,0a6.4,6.4,0,0,1,5.56,2.57A9.89,9.89,0,0,1,33,8.51a15.49,15.49,0,0,1-4.58,10.9A33.72,33.72,0,0,1,20.93,25ZM1.31,25l-.8-1.64a32.27,32.27,0,0,0,4.72-3.88q3.2-3.29,3.2-6,0-1.64-1.45-1.64H5.38A5.3,5.3,0,0,1,2,10.75,5.63,5.63,0,0,1,0,6,5.87,5.87,0,0,1,1.67,1.62,5.91,5.91,0,0,1,6,0a6.4,6.4,0,0,1,5.56,2.57,9.89,9.89,0,0,1,1.85,5.93A15.49,15.49,0,0,1,8.8,19.4,33.72,33.72,0,0,1,1.31,25Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/quote-close.svg
// module id = 303
// module chunks = 0 1